import { useMemo } from "react";
import { VideoMeetingControls } from "./VideoMeetingControls";
import { VideoMeetingActiveTab } from "../../videoMeeting.types";
import { useChatUnreadCount } from "@core/features/chat";
import { useFetchUserCircles } from "@core/features/circle";
import { useTalkJSData } from "@platform/hooks/useChat";
import { useVideoUI, usePlatformStore } from "@platform/store";

export function VideoMeetingControlsContainer() {
  const { isSidebarOpen, activeTab, openSidebar, closeSidebar } = useVideoUI();
  const talkjsData = useTalkJSData();
  const allowedConversationIds = useMemo(
    () =>
      talkjsData?.conversations.map((c) => c.talkjs_conversation_id) ?? [],
    [talkjsData]
  );
  const unreadCount = useChatUnreadCount(allowedConversationIds);
  const user = usePlatformStore((s) => s.user);
  const { data: circlesData } = useFetchUserCircles({ user });
  const userCircles = circlesData?.circles ?? null;

  const handleMenuClick = (tab: VideoMeetingActiveTab) => {
    if (isSidebarOpen && activeTab === tab) {
      closeSidebar();
    } else {
      openSidebar(tab);
    }
  };

  const handleCloseSidebar = () => {
    closeSidebar();
  };

  return (
    <VideoMeetingControls
      onMenuClick={handleMenuClick}
      closeSidebar={handleCloseSidebar}
      isSidebarOpen={isSidebarOpen}
      activeTab={activeTab}
      unreadCount={unreadCount}
      userCircles={userCircles}
    />
  );
}
